import { JSX } from "react";

import { LocalMall, Store, Train } from "@mui/icons-material";
import { Theme } from "@mui/material";
import LocationType from "src/types/LocationType";

export const getStyles = (theme: Theme) => ({
  icon: {
    fontSize: theme.fontSizes.lg,
  },
  listItemButton: (open: boolean, firstLevel: boolean = false) => ({
    minHeight: 32,
    py: 0,
    pl: firstLevel ? 2 : 1.25,
    pr: 1,
    justifyContent: open ? "initial" : "center",
    "&.Mui-disabled": {
      opacity: 0.9,
    },
  }),
  listItemIcon: (open: boolean) => ({
    minWidth: 0,
    justifyContent: "center",
    mr: open ? 1 : "auto",
    "& svg": {
      fontSize: theme.fontSizes.lg,
    },
  }),
  listItemText: (open: boolean) => ({
    display: open ? "block" : "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.fontSizes.md,
  }),
  childListItemText: (open: boolean) => ({
    ...getStyles(theme).listItemText(open),
  }),
  border: {
    borderLeft: `${theme.spacing(0.25)} solid`,
    borderColor: theme.palette.border.default,
    ml: 2.8,
  },
  listItemPrimaryTypographyProps: {
    sx: {
      fontWeight: theme.typography.fontWeightRegular,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontSize: theme.fontSizes.md,
    },
  },
});

export function getIconFromLocationType(locationType: LocationType): JSX.Element | null {
  if (locationType === LocationType.Shop) {
    return <Store />;
  }
  if (locationType === LocationType.Mall) {
    return <LocalMall />;
  }
  if (locationType === LocationType.Station) {
    return <Train />;
  }
  return null;
}

export function getDestinationRouteFromLocationType(locationType: LocationType, locationId?: string, isRegion: boolean = false): string {
  if (!locationId) {
    return locationType === LocationType.Shop ? "/shop-region-dashboard/" : "/";
  }

  switch (locationType) {
    case LocationType.Station:
      return isRegion ? `/station-region-dashboard/${locationId}` : `/station-dashboard/${locationId}`;

    case LocationType.Shop:
      return isRegion ? `/shop-region-dashboard/${locationId}` : `/shop-dashboard/${locationId}`;

    case LocationType.Mall:
      return isRegion ? `/center-region-dashboard/${locationId}` : `/center-dashboard/${locationId}`;

    default:
      return "/";
  }
}

export function getParentDisabledAndNoChildsDestinationRoute(locationType: LocationType): string {
  if (locationType === LocationType.Shop) {
    return `/shop-dashboard/`;
  }
  if (locationType === LocationType.Mall) {
    return `/center-dashboard/`;
  }
  return "/";
}

export function getParentDisabledAndNoChildsText(locationType: LocationType): string {
  if (locationType === LocationType.Shop) {
    return `Shop Dashboard`;
  }
  if (locationType === LocationType.Mall) {
    return `Center Dashboard`;
  }
  return "/";
}

export function getListItemTextFromLocationType(locationType: LocationType): string {
  if (locationType === LocationType.Shop) {
    return "Shops";
  }
  if (locationType === LocationType.Mall) {
    return "centers";
  }
  if (locationType === LocationType.Station) {
    return "Stations";
  }
  return "";
}

export function isChildMenuItemSelected(pathname: string, locationId: string, locationType: LocationType): boolean {
  if (locationType === LocationType.Mall) {
    return pathname.includes(`center-dashboard/${locationId}`);
  }
  if (locationType === LocationType.Shop) {
    return pathname.includes(`shop-dashboard/${locationId}`);
  }
  if (locationType === LocationType.Station) {
    return pathname.includes(`station-dashboard/${locationId}`);
  }
  return false;
}

export function isParentMenuItemSelected(pathname: string, locationId: string, locationType: LocationType): boolean {
  if (locationType === LocationType.Mall) {
    return pathname.includes(`center-region-dashboard/${locationId}`);
  }

  if (locationType === LocationType.Shop) {
    return pathname.includes(`shop-region-dashboard/${locationId}`);
  }

  if (locationType === LocationType.Station) {
    return pathname.includes(`station-region-dashboard/${locationId}`);
  }

  return false;
}
